export const thumbnailUrl = 'assets/images/car_thumbnail.jpg';
